// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* 90% zoom effect - reduce base font size */
  font-size: 14px;
  line-height: 1.4;
}

/* Global border color override for slate-100 */
* {
  border-color: rgb(241 245 249) !important; /* slate-100 */
}

/* ===== ENHANCED TYPOGRAPHY SYSTEM ===== */
/* Reduced font sizes for different text elements - using CSS variables when possible */
h1 {
  font-size: 1.5rem !important; /* 24px instead of 2rem/32px */
  line-height: 1.3 !important;
  font-weight: 600;
  color: var(--color-neutral-900, #171717);
}

h2 {
  font-size: 1.25rem !important; /* 20px instead of 1.5rem/24px */
  line-height: 1.3 !important;
  font-weight: 600;
  color: var(--color-neutral-800, #262626);
}

h3 {
  font-size: 1.125rem !important; /* 18px instead of 1.25rem/20px */
  line-height: 1.3 !important;
  font-weight: 600;
  color: var(--color-neutral-800, #262626);
}

h4 {
  font-size: 1rem !important; /* 16px instead of 1.125rem/18px */
  line-height: 1.3 !important;
  font-weight: 500;
  color: var(--color-neutral-700, #404040);
}

h5 {
  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */
  line-height: 1.3 !important;
  font-weight: 500;
  color: var(--color-neutral-700, #404040);
}

h6 {
  font-size: 0.75rem !important; /* 12px instead of 0.875rem/14px */
  line-height: 1.3 !important;
  font-weight: 500;
  color: var(--color-neutral-600, #525252);
}

p {
  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */
  line-height: 1.4 !important;
  color: var(--color-neutral-600, #525252);
}

/* ===== ENHANCED COMPONENT STYLES ===== */
/* Reduced spacing for common elements - enhanced with design system */
.card, .Card {
  padding: 0.75rem !important; /* 12px instead of 1rem/16px */
  margin: 0.5rem !important; /* 8px instead of 0.75rem/12px */
  border-radius: 0.75rem !important; /* 12px - consistent with design system */
  border: 1px solid var(--color-neutral-200, #e5e5e5) !important;
  background-color: white !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
}

.button, .Button {
  padding: 0.5rem 0.75rem !important; /* 8px 12px instead of 0.75rem 1rem */
  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */
  border-radius: 0.5rem !important; /* 8px - consistent with design system */
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
  min-height: 32px !important; /* Consistent button height */
}

.input, .Input {
  padding: 0.5rem !important; /* 8px instead of 0.75rem/12px */
  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */
  border-radius: 0.5rem !important; /* 8px - consistent with design system */
  border: 1px solid var(--color-neutral-300, #d4d4d4) !important;
  transition: all 0.2s ease !important;
}

.table, .Table {
  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */
  border-collapse: collapse !important;
  width: 100% !important;
}

.table th, .Table th {
  padding: 0.5rem !important; /* 8px instead of 0.75rem/12px */
  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */
  background-color: var(--color-neutral-50, #fafafa) !important;
  color: var(--color-neutral-700, #404040) !important;
  font-weight: 600 !important;
  border-bottom: 1px solid var(--color-neutral-200, #e5e5e5) !important;
}

.table td, .Table td {
  padding: 0.5rem !important; /* 8px instead of 0.75rem/12px */
  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */
  color: var(--color-neutral-600, #525252) !important;
  border-bottom: 1px solid var(--color-neutral-100, #f5f5f5) !important;
}

/* ===== ENHANCED SPACING SYSTEM ===== */
/* Reduced gaps and spacing - enhanced with design system */
.gap-1 { gap: 0.25rem !important; } /* 4px instead of 0.25rem/4px */
.gap-2 { gap: 0.375rem !important; } /* 6px instead of 0.5rem/8px */
.gap-3 { gap: 0.5rem !important; } /* 8px instead of 0.75rem/12px */
.gap-4 { gap: 0.625rem !important; } /* 10px instead of 1rem/16px */
.gap-5 { gap: 0.75rem !important; } /* 12px instead of 1.25rem/20px */
.gap-6 { gap: 0.875rem !important; } /* 14px instead of 1.5rem/24px */
.gap-8 { gap: 1.125rem !important; } /* 18px instead of 2rem/32px */

/* Reduced padding - enhanced with design system */
.p-1 { padding: 0.25rem !important; }
.p-2 { padding: 0.375rem !important; }
.p-3 { padding: 0.5rem !important; }
.p-4 { padding: 0.625rem !important; }
.p-5 { padding: 0.75rem !important; }
.p-6 { padding: 0.875rem !important; }
.p-8 { padding: 1.125rem !important; }

/* Line clamp utilities for text truncation */
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
}

.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
}

/* Reduced margin - enhanced with design system */
.m-1 { margin: 0.25rem !important; }
.m-2 { margin: 0.375rem !important; }
.m-3 { margin: 0.5rem !important; }
.m-4 { margin: 0.625rem !important; }
.m-5 { margin: 0.75rem !important; }
.m-6 { margin: 0.875rem !important; }
.m-8 { margin: 1.125rem !important; }

/* ===== ENHANCED TEXT SYSTEM ===== */
/* Reduced text sizes - enhanced with design system */
.text-xs { font-size: 0.75rem !important; } /* 12px */
.text-sm { font-size: 0.8125rem !important; } /* 13px instead of 0.875rem/14px */
.text-base { font-size: 0.875rem !important; } /* 14px instead of 1rem/16px */
.text-lg { font-size: 1rem !important; } /* 16px instead of 1.125rem/18px */
.text-xl { font-size: 1.125rem !important; } /* 18px instead of 1.25rem/20px */
.text-2xl { font-size: 1.25rem !important; } /* 20px instead of 1.5rem/24px */
.text-3xl { font-size: 1.5rem !important; } /* 24px instead of 1.875rem/30px */

/* ===== ENHANCED CODE STYLES ===== */
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */
  background-color: var(--color-neutral-100, #f5f5f5) !important;
  padding: 0.125rem 0.25rem !important;
  border-radius: 0.25rem !important;
  color: var(--color-neutral-800, #262626) !important;
}

.redKeys {
  color: red;
}

/* ===== ENHANCED NEXTUI COMPONENT OVERRIDES ===== */
/* Override NextUI component sizes - enhanced with design system */
[data-slot="base"] {
  font-size: 0.875rem !important;
}

/* Chip component adjustments - enhanced with design system */
[data-slot="chip"] {
  font-size: 0.75rem !important; /* 12px */
  padding: 0.25rem 0.5rem !important; /* 4px 8px */
  border-radius: 0.375rem !important; /* 6px - consistent with design system */
  font-weight: 500 !important;
}

/* Badge component adjustments - enhanced with design system */
[data-slot="badge"] {
  font-size: 0.75rem !important; /* 12px */
  padding: 0.125rem 0.375rem !important; /* 2px 6px */
  border-radius: 0.375rem !important; /* 6px - consistent with design system */
  font-weight: 500 !important;
}

/* Dropdown adjustments - enhanced with design system */
[data-slot="dropdown"] {
  font-size: 0.875rem !important; /* 14px */
  border-radius: 0.5rem !important; /* 8px - consistent with design system */
}

/* Modal adjustments - enhanced with design system */
[data-slot="modal"] {
  font-size: 0.875rem !important; /* 14px */
  border-radius: 0.75rem !important; /* 12px - consistent with design system */
}

/* Tooltip adjustments - enhanced with design system */
[data-slot="tooltip"] {
  font-size: 0.75rem !important; /* 12px */
  border-radius: 0.375rem !important; /* 6px - consistent with design system */
}

/* ===== ADDITIONAL ENHANCEMENTS ===== */
/* Enhanced focus states for accessibility */
button:focus,
input:focus,
select:focus,
textarea:focus {
  outline: 2px solid var(--color-primary-500, #10b981) !important;
  outline-offset: 2px !important;
}

/* Enhanced hover states for interactive elements */
button:hover,
input:hover,
select:hover,
textarea:hover {
  border-color: var(--color-neutral-400, #a3a3a3) !important;
}

/* Consistent border radius for form elements */
input,
select,
textarea,
button {
  border-radius: 0.5rem !important; /* 8px - consistent with design system */
}

/* Enhanced link styles */
a {
  color: var(--color-primary-600, #059669) !important;
  text-decoration: none !important;
  transition: color 0.2s ease !important;
}

a:hover {
  color: var(--color-primary-700, #047857) !important;
  text-decoration: underline !important;
}

/* ===== TEXT CONTRAST FIXES ===== */
/* Override any white or light text to ensure readability */
.text-white,
.text-light,
.text-transparent,
[class*="text-white"],
[class*="text-light"] {
  color: var(--color-neutral-800, #262626) !important;
}

/* Ensure all text elements have proper contrast */
* {
  color: var(--color-neutral-700, #404040) !important;
}

/* But allow specific elements to override */
h1, h2, h3, h4, h5, h6 {
  color: var(--color-neutral-900, #171717) !important;
}

.btn-primary,
.btn-success,
.btn-danger,
.btn-warning,
.btn-info {
  color: white !important; /* Buttons can have white text */
}

/* Fix NextUI component text visibility */
[data-slot="base"] {
  color: var(--color-neutral-800, #262626) !important;
}

[data-slot="input"],
[data-slot="select"],
[data-slot="textarea"] {
  color: var(--color-neutral-800, #262626) !important;
}

[data-slot="label"] {
  color: var(--color-neutral-800, #262626) !important;
  font-weight: var(--font-weight-medium, 500) !important;
}

/* Ensure form elements are always readable */
input,
textarea,
select {
  color: var(--color-neutral-800, #262626) !important;
}

/* Fix placeholder text visibility */
::placeholder {
  color: var(--color-neutral-500, #737373) !important;
  opacity: 1 !important;
}

/* Ensure dropdown options are visible */
option {
  color: var(--color-neutral-800, #262626) !important;
  background-color: white !important;
}

/* Fix any remaining light text issues */
.text-gray-300,
.text-gray-400,
.text-slate-300,
.text-slate-400,
.text-neutral-300,
.text-neutral-400 {
  color: var(--color-neutral-600, #525252) !important;
}
 `, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,sBAAsB;EACtB;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,yCAAyC,EAAE,cAAc;AAC3D;;AAEA,2CAA2C;AAC3C,uFAAuF;AACvF;EACE,4BAA4B,EAAE,8BAA8B;EAC5D,2BAA2B;EAC3B,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B,EAAE,gCAAgC;EAC/D,2BAA2B;EAC3B,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B,EAAE,iCAAiC;EACjE,2BAA2B;EAC3B,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B,EAAE,kCAAkC;EAC9D,2BAA2B;EAC3B,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B,EAAE,8BAA8B;EAC9D,2BAA2B;EAC3B,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B,EAAE,kCAAkC;EACjE,2BAA2B;EAC3B,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B,EAAE,8BAA8B;EAC9D,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,0CAA0C;AAC1C,sEAAsE;AACtE;EACE,2BAA2B,EAAE,8BAA8B;EAC3D,yBAAyB,EAAE,gCAAgC;EAC3D,iCAAiC,EAAE,yCAAyC;EAC5E,8DAA8D;EAC9D,kCAAkC;EAClC,sDAAsD;AACxD;;AAEA;EACE,kCAAkC,EAAE,qCAAqC;EACzE,8BAA8B,EAAE,8BAA8B;EAC9D,gCAAgC,EAAE,wCAAwC;EAC1E,2BAA2B;EAC3B,oCAAoC;EACpC,2BAA2B,EAAE,6BAA6B;AAC5D;;AAEA;EACE,0BAA0B,EAAE,gCAAgC;EAC5D,8BAA8B,EAAE,8BAA8B;EAC9D,gCAAgC,EAAE,wCAAwC;EAC1E,8DAA8D;EAC9D,oCAAoC;AACtC;;AAEA;EACE,8BAA8B,EAAE,8BAA8B;EAC9D,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,0BAA0B,EAAE,gCAAgC;EAC5D,8BAA8B,EAAE,8BAA8B;EAC9D,6DAA6D;EAC7D,mDAAmD;EACnD,2BAA2B;EAC3B,qEAAqE;AACvE;;AAEA;EACE,0BAA0B,EAAE,gCAAgC;EAC5D,8BAA8B,EAAE,8BAA8B;EAC9D,mDAAmD;EACnD,qEAAqE;AACvE;;AAEA,wCAAwC;AACxC,2DAA2D;AAC3D,SAAS,uBAAuB,EAAE,EAAE,+BAA+B;AACnE,SAAS,wBAAwB,EAAE,EAAE,8BAA8B;AACnE,SAAS,sBAAsB,EAAE,EAAE,gCAAgC;AACnE,SAAS,wBAAwB,EAAE,EAAE,8BAA8B;AACnE,SAAS,uBAAuB,EAAE,EAAE,iCAAiC;AACrE,SAAS,wBAAwB,EAAE,EAAE,gCAAgC;AACrE,SAAS,wBAAwB,EAAE,EAAE,8BAA8B;;AAEnE,kDAAkD;AAClD,OAAO,2BAA2B,EAAE;AACpC,OAAO,4BAA4B,EAAE;AACrC,OAAO,0BAA0B,EAAE;AACnC,OAAO,4BAA4B,EAAE;AACrC,OAAO,2BAA2B,EAAE;AACpC,OAAO,4BAA4B,EAAE;AACrC,OAAO,4BAA4B,EAAE;;AAErC,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;AACf;;AAEA,iDAAiD;AACjD,OAAO,0BAA0B,EAAE;AACnC,OAAO,2BAA2B,EAAE;AACpC,OAAO,yBAAyB,EAAE;AAClC,OAAO,2BAA2B,EAAE;AACpC,OAAO,0BAA0B,EAAE;AACnC,OAAO,2BAA2B,EAAE;AACpC,OAAO,2BAA2B,EAAE;;AAEpC,qCAAqC;AACrC,qDAAqD;AACrD,WAAW,6BAA6B,EAAE,EAAE,SAAS;AACrD,WAAW,+BAA+B,EAAE,EAAE,kCAAkC;AAChF,aAAa,8BAA8B,EAAE,EAAE,8BAA8B;AAC7E,WAAW,0BAA0B,EAAE,EAAE,kCAAkC;AAC3E,WAAW,8BAA8B,EAAE,EAAE,iCAAiC;AAC9E,YAAY,6BAA6B,EAAE,EAAE,gCAAgC;AAC7E,YAAY,4BAA4B,EAAE,EAAE,kCAAkC;;AAE9E,qCAAqC;AACrC;EACE;aACW;EACX,8BAA8B,EAAE,8BAA8B;EAC9D,8DAA8D;EAC9D,oCAAoC;EACpC,iCAAiC;EACjC,mDAAmD;AACrD;;AAEA;EACE,UAAU;AACZ;;AAEA,oDAAoD;AACpD,kEAAkE;AAClE;EACE,8BAA8B;AAChC;;AAEA,6DAA6D;AAC7D;EACE,6BAA6B,EAAE,SAAS;EACxC,kCAAkC,EAAE,YAAY;EAChD,kCAAkC,EAAE,wCAAwC;EAC5E,2BAA2B;AAC7B;;AAEA,8DAA8D;AAC9D;EACE,6BAA6B,EAAE,SAAS;EACxC,qCAAqC,EAAE,YAAY;EACnD,kCAAkC,EAAE,wCAAwC;EAC5E,2BAA2B;AAC7B;;AAEA,uDAAuD;AACvD;EACE,8BAA8B,EAAE,SAAS;EACzC,gCAAgC,EAAE,wCAAwC;AAC5E;;AAEA,oDAAoD;AACpD;EACE,8BAA8B,EAAE,SAAS;EACzC,iCAAiC,EAAE,yCAAyC;AAC9E;;AAEA,sDAAsD;AACtD;EACE,6BAA6B,EAAE,SAAS;EACxC,kCAAkC,EAAE,wCAAwC;AAC9E;;AAEA,wCAAwC;AACxC,4CAA4C;AAC5C;;;;EAIE,+DAA+D;EAC/D,8BAA8B;AAChC;;AAEA,mDAAmD;AACnD;;;;EAIE,0DAA0D;AAC5D;;AAEA,+CAA+C;AAC/C;;;;EAIE,gCAAgC,EAAE,wCAAwC;AAC5E;;AAEA,yBAAyB;AACzB;EACE,mDAAmD;EACnD,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,mDAAmD;EACnD,qCAAqC;AACvC;;AAEA,oCAAoC;AACpC,2DAA2D;AAC3D;;;;;EAKE,mDAAmD;AACrD;;AAEA,kDAAkD;AAClD;EACE,mDAAmD;AACrD;;AAEA,4CAA4C;AAC5C;EACE,mDAAmD;AACrD;;AAEA;;;;;EAKE,uBAAuB,EAAE,gCAAgC;AAC3D;;AAEA,yCAAyC;AACzC;EACE,mDAAmD;AACrD;;AAEA;;;EAGE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;EACnD,sDAAsD;AACxD;;AAEA,6CAA6C;AAC7C;;;EAGE,mDAAmD;AACrD;;AAEA,oCAAoC;AACpC;EACE,mDAAmD;EACnD,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;EACE,mDAAmD;EACnD,kCAAkC;AACpC;;AAEA,wCAAwC;AACxC;;;;;;EAME,mDAAmD;AACrD","sourcesContent":["body {\n  margin: 0;\n  box-sizing: border-box;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* 90% zoom effect - reduce base font size */\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n/* Global border color override for slate-100 */\n* {\n  border-color: rgb(241 245 249) !important; /* slate-100 */\n}\n\n/* ===== ENHANCED TYPOGRAPHY SYSTEM ===== */\n/* Reduced font sizes for different text elements - using CSS variables when possible */\nh1 {\n  font-size: 1.5rem !important; /* 24px instead of 2rem/32px */\n  line-height: 1.3 !important;\n  font-weight: 600;\n  color: var(--color-neutral-900, #171717);\n}\n\nh2 {\n  font-size: 1.25rem !important; /* 20px instead of 1.5rem/24px */\n  line-height: 1.3 !important;\n  font-weight: 600;\n  color: var(--color-neutral-800, #262626);\n}\n\nh3 {\n  font-size: 1.125rem !important; /* 18px instead of 1.25rem/20px */\n  line-height: 1.3 !important;\n  font-weight: 600;\n  color: var(--color-neutral-800, #262626);\n}\n\nh4 {\n  font-size: 1rem !important; /* 16px instead of 1.125rem/18px */\n  line-height: 1.3 !important;\n  font-weight: 500;\n  color: var(--color-neutral-700, #404040);\n}\n\nh5 {\n  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */\n  line-height: 1.3 !important;\n  font-weight: 500;\n  color: var(--color-neutral-700, #404040);\n}\n\nh6 {\n  font-size: 0.75rem !important; /* 12px instead of 0.875rem/14px */\n  line-height: 1.3 !important;\n  font-weight: 500;\n  color: var(--color-neutral-600, #525252);\n}\n\np {\n  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */\n  line-height: 1.4 !important;\n  color: var(--color-neutral-600, #525252);\n}\n\n/* ===== ENHANCED COMPONENT STYLES ===== */\n/* Reduced spacing for common elements - enhanced with design system */\n.card, .Card {\n  padding: 0.75rem !important; /* 12px instead of 1rem/16px */\n  margin: 0.5rem !important; /* 8px instead of 0.75rem/12px */\n  border-radius: 0.75rem !important; /* 12px - consistent with design system */\n  border: 1px solid var(--color-neutral-200, #e5e5e5) !important;\n  background-color: white !important;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;\n}\n\n.button, .Button {\n  padding: 0.5rem 0.75rem !important; /* 8px 12px instead of 0.75rem 1rem */\n  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */\n  border-radius: 0.5rem !important; /* 8px - consistent with design system */\n  font-weight: 500 !important;\n  transition: all 0.2s ease !important;\n  min-height: 32px !important; /* Consistent button height */\n}\n\n.input, .Input {\n  padding: 0.5rem !important; /* 8px instead of 0.75rem/12px */\n  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */\n  border-radius: 0.5rem !important; /* 8px - consistent with design system */\n  border: 1px solid var(--color-neutral-300, #d4d4d4) !important;\n  transition: all 0.2s ease !important;\n}\n\n.table, .Table {\n  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */\n  border-collapse: collapse !important;\n  width: 100% !important;\n}\n\n.table th, .Table th {\n  padding: 0.5rem !important; /* 8px instead of 0.75rem/12px */\n  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */\n  background-color: var(--color-neutral-50, #fafafa) !important;\n  color: var(--color-neutral-700, #404040) !important;\n  font-weight: 600 !important;\n  border-bottom: 1px solid var(--color-neutral-200, #e5e5e5) !important;\n}\n\n.table td, .Table td {\n  padding: 0.5rem !important; /* 8px instead of 0.75rem/12px */\n  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */\n  color: var(--color-neutral-600, #525252) !important;\n  border-bottom: 1px solid var(--color-neutral-100, #f5f5f5) !important;\n}\n\n/* ===== ENHANCED SPACING SYSTEM ===== */\n/* Reduced gaps and spacing - enhanced with design system */\n.gap-1 { gap: 0.25rem !important; } /* 4px instead of 0.25rem/4px */\n.gap-2 { gap: 0.375rem !important; } /* 6px instead of 0.5rem/8px */\n.gap-3 { gap: 0.5rem !important; } /* 8px instead of 0.75rem/12px */\n.gap-4 { gap: 0.625rem !important; } /* 10px instead of 1rem/16px */\n.gap-5 { gap: 0.75rem !important; } /* 12px instead of 1.25rem/20px */\n.gap-6 { gap: 0.875rem !important; } /* 14px instead of 1.5rem/24px */\n.gap-8 { gap: 1.125rem !important; } /* 18px instead of 2rem/32px */\n\n/* Reduced padding - enhanced with design system */\n.p-1 { padding: 0.25rem !important; }\n.p-2 { padding: 0.375rem !important; }\n.p-3 { padding: 0.5rem !important; }\n.p-4 { padding: 0.625rem !important; }\n.p-5 { padding: 0.75rem !important; }\n.p-6 { padding: 0.875rem !important; }\n.p-8 { padding: 1.125rem !important; }\n\n/* Line clamp utilities for text truncation */\n.line-clamp-1 {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  line-clamp: 1;\n}\n\n.line-clamp-2 {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n}\n\n.line-clamp-3 {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n}\n\n/* Reduced margin - enhanced with design system */\n.m-1 { margin: 0.25rem !important; }\n.m-2 { margin: 0.375rem !important; }\n.m-3 { margin: 0.5rem !important; }\n.m-4 { margin: 0.625rem !important; }\n.m-5 { margin: 0.75rem !important; }\n.m-6 { margin: 0.875rem !important; }\n.m-8 { margin: 1.125rem !important; }\n\n/* ===== ENHANCED TEXT SYSTEM ===== */\n/* Reduced text sizes - enhanced with design system */\n.text-xs { font-size: 0.75rem !important; } /* 12px */\n.text-sm { font-size: 0.8125rem !important; } /* 13px instead of 0.875rem/14px */\n.text-base { font-size: 0.875rem !important; } /* 14px instead of 1rem/16px */\n.text-lg { font-size: 1rem !important; } /* 16px instead of 1.125rem/18px */\n.text-xl { font-size: 1.125rem !important; } /* 18px instead of 1.25rem/20px */\n.text-2xl { font-size: 1.25rem !important; } /* 20px instead of 1.5rem/24px */\n.text-3xl { font-size: 1.5rem !important; } /* 24px instead of 1.875rem/30px */\n\n/* ===== ENHANCED CODE STYLES ===== */\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n  font-size: 0.875rem !important; /* 14px instead of 1rem/16px */\n  background-color: var(--color-neutral-100, #f5f5f5) !important;\n  padding: 0.125rem 0.25rem !important;\n  border-radius: 0.25rem !important;\n  color: var(--color-neutral-800, #262626) !important;\n}\n\n.redKeys {\n  color: red;\n}\n\n/* ===== ENHANCED NEXTUI COMPONENT OVERRIDES ===== */\n/* Override NextUI component sizes - enhanced with design system */\n[data-slot=\"base\"] {\n  font-size: 0.875rem !important;\n}\n\n/* Chip component adjustments - enhanced with design system */\n[data-slot=\"chip\"] {\n  font-size: 0.75rem !important; /* 12px */\n  padding: 0.25rem 0.5rem !important; /* 4px 8px */\n  border-radius: 0.375rem !important; /* 6px - consistent with design system */\n  font-weight: 500 !important;\n}\n\n/* Badge component adjustments - enhanced with design system */\n[data-slot=\"badge\"] {\n  font-size: 0.75rem !important; /* 12px */\n  padding: 0.125rem 0.375rem !important; /* 2px 6px */\n  border-radius: 0.375rem !important; /* 6px - consistent with design system */\n  font-weight: 500 !important;\n}\n\n/* Dropdown adjustments - enhanced with design system */\n[data-slot=\"dropdown\"] {\n  font-size: 0.875rem !important; /* 14px */\n  border-radius: 0.5rem !important; /* 8px - consistent with design system */\n}\n\n/* Modal adjustments - enhanced with design system */\n[data-slot=\"modal\"] {\n  font-size: 0.875rem !important; /* 14px */\n  border-radius: 0.75rem !important; /* 12px - consistent with design system */\n}\n\n/* Tooltip adjustments - enhanced with design system */\n[data-slot=\"tooltip\"] {\n  font-size: 0.75rem !important; /* 12px */\n  border-radius: 0.375rem !important; /* 6px - consistent with design system */\n}\n\n/* ===== ADDITIONAL ENHANCEMENTS ===== */\n/* Enhanced focus states for accessibility */\nbutton:focus,\ninput:focus,\nselect:focus,\ntextarea:focus {\n  outline: 2px solid var(--color-primary-500, #10b981) !important;\n  outline-offset: 2px !important;\n}\n\n/* Enhanced hover states for interactive elements */\nbutton:hover,\ninput:hover,\nselect:hover,\ntextarea:hover {\n  border-color: var(--color-neutral-400, #a3a3a3) !important;\n}\n\n/* Consistent border radius for form elements */\ninput,\nselect,\ntextarea,\nbutton {\n  border-radius: 0.5rem !important; /* 8px - consistent with design system */\n}\n\n/* Enhanced link styles */\na {\n  color: var(--color-primary-600, #059669) !important;\n  text-decoration: none !important;\n  transition: color 0.2s ease !important;\n}\n\na:hover {\n  color: var(--color-primary-700, #047857) !important;\n  text-decoration: underline !important;\n}\n\n/* ===== TEXT CONTRAST FIXES ===== */\n/* Override any white or light text to ensure readability */\n.text-white,\n.text-light,\n.text-transparent,\n[class*=\"text-white\"],\n[class*=\"text-light\"] {\n  color: var(--color-neutral-800, #262626) !important;\n}\n\n/* Ensure all text elements have proper contrast */\n* {\n  color: var(--color-neutral-700, #404040) !important;\n}\n\n/* But allow specific elements to override */\nh1, h2, h3, h4, h5, h6 {\n  color: var(--color-neutral-900, #171717) !important;\n}\n\n.btn-primary,\n.btn-success,\n.btn-danger,\n.btn-warning,\n.btn-info {\n  color: white !important; /* Buttons can have white text */\n}\n\n/* Fix NextUI component text visibility */\n[data-slot=\"base\"] {\n  color: var(--color-neutral-800, #262626) !important;\n}\n\n[data-slot=\"input\"],\n[data-slot=\"select\"],\n[data-slot=\"textarea\"] {\n  color: var(--color-neutral-800, #262626) !important;\n}\n\n[data-slot=\"label\"] {\n  color: var(--color-neutral-800, #262626) !important;\n  font-weight: var(--font-weight-medium, 500) !important;\n}\n\n/* Ensure form elements are always readable */\ninput,\ntextarea,\nselect {\n  color: var(--color-neutral-800, #262626) !important;\n}\n\n/* Fix placeholder text visibility */\n::placeholder {\n  color: var(--color-neutral-500, #737373) !important;\n  opacity: 1 !important;\n}\n\n/* Ensure dropdown options are visible */\noption {\n  color: var(--color-neutral-800, #262626) !important;\n  background-color: white !important;\n}\n\n/* Fix any remaining light text issues */\n.text-gray-300,\n.text-gray-400,\n.text-slate-300,\n.text-slate-400,\n.text-neutral-300,\n.text-neutral-400 {\n  color: var(--color-neutral-600, #525252) !important;\n}\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
